// Impure runner for the Set Summary Excel download. Pairs with the pure
// spec builder in setSummaryExport.mjs (same split as collectionExportRun.js):
// this file owns the set-file import, the lazy exceljs load, the spec -> styled
// workbook translation, and the browser download.
import { SET_REGISTRY } from '../setRegistry';
import { buildWorkbookSpec } from './setSummaryExport.mjs';
import { specToWorkbook } from './setSummaryExportXlsx.mjs';
import { saveBlobFile, XLSX_MIME } from './saveBlobFile';

// Main entry, called from the SetSummary page with the summary it already
// rendered. Loads the checklist data file for the card tabs (tolerating sets
// that don't have one — the workbook then carries the Summary tab only).
export async function exportSetSummaryXlsx({ setId, summary }) {
  const reg = SET_REGISTRY.find((s) => s.id === setId);
  let sets = null;
  let fileParallels = null;
  if (reg?.dataFile) {
    try {
      const module = await import(`../sets/${reg.dataFile}.js`);
      sets = module.SETS || null;
      fileParallels = {
        PARALLELS: module.PARALLELS,
        INSERT_PARALLELS: module.INSERT_PARALLELS,
        AUTO_PARALLELS: module.AUTO_PARALLELS,
      };
    } catch {
      // No data file — export the summary tab alone.
    }
  }

  const dateISO = new Date().toISOString().slice(0, 10);
  const spec = buildWorkbookSpec({ setId, summary, sets, fileParallels, dateISO });

  // Lazy-load exceljs so it stays out of the main bundle until first click.
  const ExcelJS = (await import('exceljs')).default;
  const wb = specToWorkbook(ExcelJS, spec);
  const buffer = await wb.xlsx.writeBuffer();
  await saveBlobFile(new Blob([buffer], { type: XLSX_MIME }), spec.filename);
}
